import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.application.details.title',
    defaultMessage: 'APPLICATIONS',
  },
  back: {
    id: 'reports.application.details.back',
    defaultMessage: 'Back',
  },
  school: {
    id: 'reports.application.details.school',
    defaultMessage: 'School',
  },
  class: {
    id: 'reports.application.details.class',
    defaultMessage: 'Class',
  },
  chain: {
    id: 'reports.application.details.chain',
    defaultMessage: 'Chain',
  },
  totalStudents: {
    id: 'reports.application.details.totalStudents',
    defaultMessage: 'Total students',
  },
  averageHits: {
    id: 'reports.application.details.averageHits',
    defaultMessage: 'Average hits',
  },
  averageErrors: {
    id: 'reports.application.details.averageErrors',
    defaultMessage: 'Average errors',
  },
  generalPerformance: {
    id: 'reports.application.details.generalPerformance',
    defaultMessage: 'Overall performance',
  },
  generalPerformanceByClass: {
    id: 'reports.application.details.generalPerformanceByClass',
    defaultMessage: 'Overall performance by series',
  },
  generalPerformanceByComponent: {
    id: 'reports.application.details.generalPerformanceByComponent',
    defaultMessage: 'Overall performance by curriculum component',
  },
  generatePdf: {
    id: 'reports.application.details.generatePdf',
    defaultMessage: 'Download PDF',
  },
  see: {
    id: 'reports.application.details.see',
    defaultMessage: 'See',
  },
  studentsRanking: {
    id: 'reports.application.details.studentsRanking',
    defaultMessage: 'Student ranking',
  },
  assessmentPanel: {
    id: 'reports.application.details.assessmentPanel',
    defaultMessage: 'AssessmentPanel',
  },
  classesStudents: {
    id: 'reports.application.details.classesStudents',
    defaultMessage: 'Class and Students',
  },
  questions: {
    id: 'reports.application.details.questions',
    defaultMessage: 'Questions',
  },
  components: {
    id: 'reports.application.details.components',
    defaultMessage: 'Components',
  },
  abilities: {
    id: 'reports.application.details.abilities',
    defaultMessage: 'Abilities',
  },
  reportCard: {
    id: 'reports.application.details.reportCard',
    defaultMessage: 'Report card',
  },
  filters: {
    id: 'reports.application.details.filters',
    defaultMessage: 'Filters',
  },
  clear: {
    id: 'reports.application.details.clear',
    defaultMessage: 'Clear',
  },
  knowledgeArea: {
    id: 'reports.application.details.knowledgeArea',
    defaultMessage: 'Knowledge area',
  },
  curricularComponent: {
    id: 'reports.application.details.curricularComponent',
    defaultMessage: 'Curricular component',
  },
  ability: {
    id: 'reports.application.details.ability',
    defaultMessage: 'Ability',
  },
  student: {
    id: 'reports.application.details.student',
    defaultMessage: 'Student',
  },
  bloom: {
    id: 'reports.bloom',
    defaultMessage: 'Bloom',
  },
  performanceComparison: {
    id: 'reports.application.details.performanceComparison',
    default: 'Performance Comparison',
  },
  studentPerformanceByComponent: {
    id: 'reports.application.details.studentPerformanceByComponent',
    defaultMessage: 'Student performance by curriculum component',
  },
  studentGrade: {
    id: 'reports.application.details.reportCard.studentGrade',
    defaultMessage: 'Student hits',
  },
  studentGroupAverage: {
    id: 'reports.application.details.reportCard.studentGroupAverage',
    defaultMessage: 'Class Average',
  },
  schoolAverage: {
    id: 'reports.application.details.reportCard.schoolAverage',
    defaultMessage: 'School average',
  },
  overallAveragePerformance: {
    id: 'reports.application.details.reportCard.overallAveragePerformance',
    defaultMessage: 'Overall average performance',
  },
  gradeByGroupError39: {
    id: 'reports.application.details.gradeByGroupError39',
    defaultMessage: 'Sorry, no information available to display',
  },
  accessEssayCorrections: {
    id: 'reports.application.details.accessEssayCorrections',
    defaultMessage: 'Access essay corrections',
  },
});
